require('./angular-idle');
module.exports = 'ngIdle';



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-idle/index.js
 ** module id = 853
 ** module chunks = 0
 **/